import type { TAllowedModule, TPermissionModule } from 'entities/workspace'

export const ALLOWED_MODULE_TO_PERMISSION_MODULE: Partial<Record<TAllowedModule, TPermissionModule>> = {
  winninLite: 'winnin-lite',
}
